import {
	RECEIVE_ALL_CITIES,
	RECEIVE_ALL_DEPARTMENTS,
	RECEIVE_ALL_FILTER_TYPES,
	RECEIVE_ALL_INDICATOR_TYPES,
	RECEIVE_ALL_INDICATORS,
	RECEIVE_ALL_MANAGEMENT_WATER,
	RECEIVE_ALL_PARAMETERS,
	RECEIVE_ALL_REMARKS,
	RECEIVE_ALL_SITE_TYPES,
	RECEIVE_ALL_STANDARD_CODIFICATION,
	RECEIVE_ALL_STATIONS,
	RECEIVE_ALL_SUPPORTS,
	RECEIVE_ALL_UNITS,
	RECEIVE_ALL_WATERSHED,
	RESET_REFERENTIAL
} from '../constants/ReferentialConstants'
import ApplicationConf from '../../conf/ApplicationConf'
import { getJson } from '../../utils/ActionUtils'
import { WaitAction } from 'react-aquasys'
import { getFetchSiteTypeAllowWithTypes } from '../../utils/ApplicationUtils'

const ReferentialAction = {
	receiveUnits: function (units) {
		return {
			type: RECEIVE_ALL_UNITS,
			units: units
		}
	},
	fetchUnits: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getUnits(),
			ReferentialAction.receiveUnits
		)
	},
	receiveRemarks: function (remarks) {
		return {
			type: RECEIVE_ALL_REMARKS,
			remarks: remarks
		}
	},

	fetchRemarks: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getRemarks(),
			ReferentialAction.receiveRemarks
		)
	},
	receiveSupports: function (supports) {
		return {
			type: RECEIVE_ALL_SUPPORTS,
			supports: supports
		}
	},
	fetchSupports: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getSupports(),
			ReferentialAction.receiveSupports
		)
	},
	receiveStandardCodifications: function (standardCodifications) {
		return {
			type: RECEIVE_ALL_STANDARD_CODIFICATION,
			standardCodifications: standardCodifications
		}
	},

	fetchStandardCodifications: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getStandardCodification(),
			ReferentialAction.receiveStandardCodifications
		)
	},
	receiveParameters: function (parameters) {
		return {
			type: RECEIVE_ALL_PARAMETERS,
			parameters: parameters
		}
	},
	fetchParameters: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getParameters(),
			ReferentialAction.receiveParameters
		)
	},
	receiveCities: function (cities) {
		return {
			type: RECEIVE_ALL_CITIES,
			cities: cities
		}
	},
	fetchCities: function () {
		return ReferentialAction.fetchPostReferencial(
			ApplicationConf.referencial.getCities(),
			ReferentialAction.receiveCities
		)
	},
	receiveDepartments: function (departments) {
		return {
			type: RECEIVE_ALL_DEPARTMENTS,
			departments: departments
		}
	},
	fetchDepartments: function () {
		return ReferentialAction.fetchPostReferencial(
			ApplicationConf.referencial.getDepartments(),
			ReferentialAction.receiveDepartments
		)
	},
	receiveFilterTypes: function (filterTypes) {
		return {
			type: RECEIVE_ALL_FILTER_TYPES,
			filterTypes: filterTypes
		}
	},
	fetchFilterTypes: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getFilterTypes(),
			ReferentialAction.receiveFilterTypes
		)
	},
	receiveSiteTypes: function (siteTypes) {
		return {
			type: RECEIVE_ALL_SITE_TYPES,
			siteTypes: siteTypes
		}
	},
	fetchSiteTypes: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getSiteTypes(),
			ReferentialAction.receiveSiteTypes
		)
	},
	receiveWatersheds: function (watersheds) {
		return {
			type: RECEIVE_ALL_WATERSHED,
			watersheds: watersheds
		}
	},
	fetchWatersheds: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getWatershed(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((json = []) => {
					if (!json.error) {
						dispatch(ReferentialAction.receiveWatersheds(json))
					}
					return []
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveManagementWaters: function (managementWaters) {
		return {
			type: RECEIVE_ALL_MANAGEMENT_WATER,
			managementWaters: managementWaters
		}
	},
	fetchManagementWaters: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getManagementWaters(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((json = []) => {
					if (!json.error) {
						dispatch(ReferentialAction.receiveManagementWaters(json))
					}
					return []
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveSimpleStations: function (stations) {
		return {
			type: RECEIVE_ALL_STATIONS,
			stations: stations
		}
	},
	fetchIndicatorTypes: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getIndicatorTypes(),
			ReferentialAction.receiveIndicatorTypes
		)
	},
	receiveIndicatorTypes: function (indicatorTypes) {
		return {
			type: RECEIVE_ALL_INDICATOR_TYPES,
			indicatorTypes: indicatorTypes
		}
	},
	fetchIndicators: function () {
		return ReferentialAction.fetchGetReferencial(
			ApplicationConf.referencial.getIndicators(),
			ReferentialAction.receiveIndicators
		)
	},
	receiveIndicators: function (indicators) {
		return {
			type: RECEIVE_ALL_INDICATORS,
			indicators: indicators
		}
	},
	fetchSimpleStations: function (parameters) {
		return ReferentialAction.fetchPostReferencial(
			ApplicationConf.referencial.getSimpleStations(),
			ReferentialAction.receiveSimpleStations,
			JSON.stringify({
				parameters: getFetchSiteTypeAllowWithTypes(parameters)
			})
		)
	},
	fetchGetReferencial: function (link, receive) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(link, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				}
			})
				.then(getJson)
				.then((json = []) => {
					if (!json.error) {
						dispatch(receive(json))
					}
					return []
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	fetchPostReferencial: function (link, receive, argument = undefined) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			const defaultResult = (() => {
				const resultParam = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					}
				}
				if (argument) {
					return Object.assign({}, resultParam, {
						body: argument
					})
				}
				return resultParam
			})()
			return fetch(link, defaultResult)
				.then(getJson)
				.then((json = []) => {
					if (!json.error) {
						dispatch(receive(json))
					}
					return []
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
		}
	},
	resetReferential: function () {
		return { type: RESET_REFERENTIAL }
	}
}
export default ReferentialAction



// WEBPACK FOOTER //
// ./src/referential/actions/ReferentialAction.js